import styled from 'styled-components';

export const GetHelpList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 0;
`;
